import React, { useCallback, useMemo } from 'react';
import { faOnHotelCategoryApply, faOnHotelCategoryRemove } from '../analytics-services';

const CategoryRating = ({
  filterOption,
  appliedValues,
  handleOptionClick,
  filterStats,
  filterUrlParam,
}) => {
  const isApplied = useMemo(
    () =>
      appliedValues?.indexOf(filterOption?.uniqueId) > -1 ||
      appliedValues?.indexOf(filterOption?.uniqueId?.toLowerCase?.()) > -1,
    [appliedValues, filterOption?.uniqueId]
  );

  const handleApplyFilter = useCallback(() => {
    if (isApplied) {
      faOnHotelCategoryRemove(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick(
        appliedValues.filter(value => value !== filterOption?.uniqueId),
        { prop54: `filter_remove_ui_<urlParam>_${filterOption?.uniqueId}` }
      );
    } else {
      faOnHotelCategoryApply(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick([...appliedValues, filterOption?.uniqueId], {
        prop54: `filter_apply_ui_<urlParam>_${filterOption?.uniqueId}`,
      });
    }
  }, [isApplied, filterOption?.uniqueId, appliedValues]);

  const count = useMemo(() => {
    const currentFilterStats = filterStats?.find(
      stat => stat.filterValue === filterOption?.uniqueId
    );

    return currentFilterStats?.packageCount;
  }, [filterOption, filterStats]);

  return (
    <span
      className={`categoryRating ${isApplied ? 'active' : ''} ${count > 0 ? '' : 'disabled'}`}
      onClick={handleApplyFilter}
    >
      <span>
        {filterOption.filterText}
        {filterOption.suffix}
      </span>
      <span className="star-rating-count">({count})</span>
      {/* <span className="icon mmt-star"></span> */}
    </span>
  );
};

export default CategoryRating;
